'use client';

import useId from '@mui/utils/useId';
export default useId;